interface Props {
  [key: string]: any
}
function CameraThinIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 20 18" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M1 6C1 5.46957 1.21071 4.96086 1.58579 4.58579C1.96086 4.21071 2.46957 4 3 4H3.93C4.25918 4.00005 4.58329 3.91884 4.87357 3.76359C5.16384 3.60834 5.4113 3.38383 5.594 3.11L6.406 1.89C6.5887 1.61617 6.83616 1.39166 7.12643 1.23641C7.41671 1.08116 7.74082 0.999951 8.07 1H11.93C12.2592 0.999951 12.5833 1.08116 12.8736 1.23641C13.1638 1.39166 13.4113 1.61617 13.594 1.89L14.406 3.11C14.5887 3.38383 14.8362 3.60834 15.1264 3.76359C15.4167 3.91884 15.7408 4.00005 16.07 4H17C17.5304 4 18.0391 4.21071 18.4142 4.58579C18.7893 4.96086 19 5.46957 19 6V15C19 15.5304 18.7893 16.0391 18.4142 16.4142C18.0391 16.7893 17.5304 17 17 17H3C2.46957 17 1.96086 16.7893 1.58579 16.4142C1.21071 16.0391 1 15.5304 1 15V6Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M13 10C13 10.7956 12.6839 11.5587 12.1213 12.1213C11.5587 12.6839 10.7956 13 10 13C9.20435 13 8.44129 12.6839 7.87868 12.1213C7.31607 11.5587 7 10.7956 7 10C7 9.20435 7.31607 8.44129 7.87868 7.87868C8.44129 7.31607 9.20435 7 10 7C10.7956 7 11.5587 7.31607 12.1213 7.87868C12.6839 8.44129 13 9.20435 13 10V10Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default CameraThinIcon
